/* eslint-disable no-unused-vars */
import { post } from "jquery";
import { Delete, Get, Post, PostFormData, Put, PutFormData } from "../Request";

export default {
  state: {
    DigitalManuals: [],
    ManualVersion:[]
  },
  getters: {
    GetDigitalManuals(state) {
      return state.DigitalManuals;
    },
    GetManualVersion(state) {
      return state.ManualVersion;
    },
  },
  actions: {
    async GetDownloadDigitalManualFile({ commit }, payload) {
      return await Get(
        `DigitalManual/DownloadDigitalManualFile/${payload}`
      ).then((res) => {
        return res.data.Data;
      });
    },

    async DeleteDigitalManualFile({ commit }, payload) {
      return await Delete(
        `DigitalManual/DeleteDigitalManualFile?Id=${payload}`
      ).then((res) => {
        return res.data;
      });
    },
    async GetDigitalManuals({ commit }, payload) {
      return await Get(
        `DigitalManual/GetDigitalManual?page=${payload.page}&pageSize=${payload.pageSize}&search=${payload.search}`
      ).then((res) => {
        const processedData = res.data.Data.List.map((item) => {
          if (item.DigitalManualFile && item.DigitalManualFile.Language) {
            item.DigitalManualFile.Language =
              item.DigitalManualFile.Language.split(",");
          }
          return item;
        });
        console.log("digital manual",processedData);
        commit("SetDigitalManuals", processedData);

        return res.data.Data;
      });
    },
    async GetManualVersion({ commit }, payload) {
      return await Get(
        `DigitalManual/GetManualVersion?page=${payload.page}&pageSize=${payload.pageSize}&search=${payload.search}`
      ).then((res) => {
        const processedData = res.data.Data.List.map((item) => {
          if (item.DigitalManualFile && item.DigitalManualFile.Language) {
            item.DigitalManualFile.Language =
              item.DigitalManualFile.Language.split(",");
          }
          return item;
        });
        commit("SetManualVersion", processedData);

        return res.data.Data;
      });
    },
    async GetDigitalArchiveManuals({ commit }, payload) {
      return await Get(
        `DigitalManual/GetDigitalArchiveManual?page=${payload.page}&pageSize=${payload.pageSize}&search=${payload.search}`
      ).then((res) => {
        commit("SetDigitalManuals", res.data.Data.List);

        return res.data.Data;
      });
    },

    async CreateDigitalManual({ commit }, payload) {
      return await PostFormData(
        "DigitalManual/CreateDigitalManual",
        payload
      ).then((res) => {
        return res.data;
      });
    },
    async UploadChunk({ commit }, payload) {
      return await PostFormData(
        "DigitalManual/upload-chunk",
        payload
      ).then((res) => {
        return res.data;
      });
    },
    async UpdateDigitalManual({ commit }, payload) {
      return await PutFormData(
        "DigitalManual/UpdateDigitalManual",
        payload
      ).then((res) => {
        return res.data;
      });
    },
    async UpdateDigitalManualFile({ commit }, payload) {
      return await PutFormData(
        "DigitalManual/UpdateDigitalManualFile",
        payload
      ).then((res) => {
        return res.data;
      });
    },
    async DeleteDigitalManual({ commit }, payload) {
      return await Delete(
        `DigitalManual/DeleteDigitalManual?Id=${payload}`
      ).then((res) => {
        return res.data;
      });
    },
    async AddArchivedDigitalManula({ commit }, payload) {
      return await Post(
        `DigitalManual/ArchiveDigitalManual?Id=${payload.Id}`,
        null
      ).then((res) => {
        return res.data;
      });
    },
  },
  mutations: {
    SetDigitalManuals(state, payload) {
      console.log("Digital manual",payload);
      state.DigitalManuals = payload;
    },
    SetManualVersion(state, payload) {
      state.ManualVersion = payload;
    },
  },
};
